// extracted by mini-css-extract-plugin
export default {"dashboard":"admin-layout_dashboard__qO+RZ","dashboard-content":"admin-layout_dashboard-content__UMlxO"};